"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _lodash = _interopRequireDefault(require("lodash.isequal"));

function isMemoizePropsEqual(prevProps, newProps) {
  var prevSelectShot = prevProps.selectShot,
      prevIsOver = prevProps.isOver,
      prevAsset = prevProps.asset,
      prevAspectRatio = prevProps.aspectRatio;

  var _ref = prevAsset || {},
      _ref$assetFiles = _ref.assetFiles;

  _ref$assetFiles = _ref$assetFiles === void 0 ? {} : _ref$assetFiles;
  var _ref$assetFiles$ORIGI = _ref$assetFiles.ORIGINAL;
  _ref$assetFiles$ORIGI = _ref$assetFiles$ORIGI === void 0 ? {} : _ref$assetFiles$ORIGI;
  var _ref$assetFiles$ORIGI2 = _ref$assetFiles$ORIGI.sourceUrl,
      prevSourceUrl = _ref$assetFiles$ORIGI2 === void 0 ? '' : _ref$assetFiles$ORIGI2;
  var selectShot = newProps.selectShot,
      isOver = newProps.isOver,
      asset = newProps.asset,
      aspectRatio = newProps.aspectRatio;

  var _ref2 = asset || {},
      _ref2$assetFiles = _ref2.assetFiles;

  _ref2$assetFiles = _ref2$assetFiles === void 0 ? {} : _ref2$assetFiles;
  var _ref2$assetFiles$ORIG = _ref2$assetFiles.ORIGINAL;
  _ref2$assetFiles$ORIG = _ref2$assetFiles$ORIG === void 0 ? {} : _ref2$assetFiles$ORIG;
  var _ref2$assetFiles$ORIG2 = _ref2$assetFiles$ORIG.sourceUrl,
      sourceUrl = _ref2$assetFiles$ORIG2 === void 0 ? '' : _ref2$assetFiles$ORIG2;

  if (!(0, _lodash.default)(prevAsset, asset)) {
    return false;
  }

  return prevSelectShot === selectShot && prevIsOver === isOver && prevSourceUrl === sourceUrl && prevAspectRatio === aspectRatio;
}

var _default = isMemoizePropsEqual;
exports.default = _default;